import React from "react";
import { isMobile } from 'react-device-detect';

export default function MovieInfo({ 
    title, 
    released, 
    runtime, 
    language, 
    director, 
    writer, 
    ratings, 
}) {    

    const renderRatings = () => {
        return (
            <div className="movie-ratings">
                <div className="rating">
                    <dt>ROTTEN TOMATOES</dt>
                    <dd>{ratings.rottentomatoes}</dd>
                </div>
                <div className="rating">
                    <dt>IMDB</dt>
                    <dd>{ratings.imdb}</dd>
                </div>
            </div>
        )
    }

    const renderInfo = () => {
        return (
            <div>
                <div className="row">
                    <div className="col-12 pb-1">
                        <span className="movieinfo-dd">DIRECTOR:</span>
                        <span className="movieinfo-dt pl-2">{director}</span>
                    </div>
                </div>
                {writer && !isMobile ?
                    <div className="row">
                        <div className="col-12 pb-1">
                            <span className="movieinfo-dd">WRITER:</span>
                            <span className="movieinfo-dt pl-2">{writer}</span>
                        </div>
                    </div>
                    : null}
                <div className="row">
                    <div className="col-12 pb-1">
                        <span className="movieinfo-dd">LANGUAGE:</span>
                        <span className="movieinfo-dt pl-2">{language}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 pb-1">
                        <span className="movieinfo-dd">RUNTIME:</span>
                        <span className="movieinfo-dt pl-2">{runtime}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 pb-1">
                        <span className="movieinfo-dd">RELEASED:</span>
                        <span className="movieinfo-dt pl-2">{released}</span>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="movie-info">
            <div className="row">
                <div className="col-12">
                    <h1 className="title">{title}</h1>
                </div>
            </div>
            {renderRatings()}
            <div className="movieinfo-details">
                {renderInfo()}
            </div>
        </div>
    );
}
